import { Visibility } from 'globalTypes'

/**
 * @param contentVisibility  Determines the visibility state of the content. @see Visibility for more info
 * @param contentCanManage  True if the user is the author of the content, false otherwise.
 * @param collectionVisibility  Determines the visibility state of the collection. @see Visibility for more info
 * @param collectionCanRead  True if the user can read the collection content, false otherwise.
 *
 * @returns True if the content in the collection can be accessed by the user, false otherwise.
 */
const canAccessContent = (
  contentVisibility: Visibility,
  contentCanManage: boolean,
  collectionVisibility: Visibility,
  collectionCanRead: boolean
) => {
  return !(
    collectionVisibility === Visibility.public &&
    contentVisibility === Visibility.protected &&
    collectionCanRead === false &&
    contentCanManage === false
  )
}

export default canAccessContent
